import getCmp from "../helpers/cmpHelpers";
import * as Modal from 'bootstrap/js/dist/modal'
const handleOnLoadModals = () => {
    const cmp = getCmp();
    if(cmp !== null){
        cmp('addEventListener', ['consent', handleConsent, false], null)
    }
    if(cmp === null){
        checkHandleModalCookie();
    }

    function handleConsent(e, o){
        checkHandleModalCookie();
    }

    function checkHandleModalCookie(){
        const allModalsThatShouldLoadInitially = document.querySelectorAll('.ume-intra-alert-modal-on-load');
        if(allModalsThatShouldLoadInitially.length > 0){
            allModalsThatShouldLoadInitially.forEach(m => {
                let modalCookieName = 'ModalShown' + m.id.toString();
                if (document.cookie.indexOf(`${modalCookieName}=true`) < 0 ) {
                    const myModal = new Modal(m, {});
                    myModal.show();
                    umeCreateCookie(modalCookieName, 'true', 1);
                    let hash = window.location.hash;
                    if(hash !== ''){
                        m.setAttribute('data-has-hash', 'true');
                        m.setAttribute('data-hash', hash);

                    }
                }
            })

        }

    }
    function umeCreateCookie(name, value, days) {
        let expires = '';
        if (days) {
            let d = new Date();
            d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + d.toGMTString();
        }
        document.cookie = name + '=' + value + expires + '; path=/';
    }
}
export  default handleOnLoadModals;